<p-toast position="top-right"  />

@if (!hasSearched) {
<div class="landing-container hide-on-print">
  <div class="landing-illustration">
    <span class="blob"></span>
    <i class="pi pi-inbox box-icon"></i>
    <i class="pi pi-search magnifier-icon"></i>
  </div>
  <h2 class="landing-title">Search Item</h2>
  <p class="landing-subtitle">Enter the Parcel ID associated with DIA or the Terminal.</p>

  <div class="landing-search-pill">
    <i class="pi pi-search left-icon"></i>
    <input #landingInput type="text" [(ngModel)]="itemId" placeholder="Search parcel"
      (keyup.enter)="onSearch(landingInput.value)" />
    <button type="button" class="search-btn" (click)="onSearch(landingInput.value)" aria-label="Search">
      <i class="pi pi-search"></i>
    </button>
  </div>
</div>
}

@if (hasSearched) {
<div class="search-results hide-on-print">
  <p-tabs [(value)]="activeTab" class="modern-tabs-1">
    <p-tablist>
      <p-tab value="parcel" [disabled]="!parcelHasResult">Parcel</p-tab>
      <p-tab value="terminal" [disabled]="!terminalHasResult">Terminal</p-tab>
      <app-search-component class="results-search" [placeHolder]="'Search parcel'"
        [itemId]="itemId" [isNotFound]="false" (onSearchClick)="onSearch($event)"></app-search-component>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="parcel">
        <app-search-parcel [hideOwnSearchBar]="true" [viewerActive]="viewersReady && activeTab === 'parcel'" (searchCleared)="onClear()"
          (searchResult)="onParcelResult($event)" ></app-search-parcel>
      </p-tabpanel>
      <p-tabpanel value="terminal">
        <app-search-parcel-terminal [hideOwnSearchBar]="true" [viewerActive]="viewersReady && activeTab === 'terminal'" (searchCleared)="onClear()"
          (searchResult)="onTerminalResult($event)"></app-search-parcel-terminal>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
}
